import router from "@/router/index.js";
import {useInfoStore} from "@/store/index.js";
import {getUserBaseInfo} from "@/utils/untils.js";
import {ElMessage, ElMessageBox} from "element-plus";

export const checkPageList = [
    {
        path: '/AIWorkBench', // ai工作台
        permissions: ['province', 'score', 'login']
    },
    {
        path: '/intention', // 志愿列表
        permissions: ['province', 'login']
    },
    {
        path: '/volunteerDetail', // 志愿详情
        permissions: ['province', 'score', 'login']
    },
    {
        path: '/choseVolunteer', // 选志愿
        permissions: ['province', 'score', 'login']
    },
    {
        path: '/ai_list', // ai工作台列表 有token才会执行校验
        permissions: ['province', 'score', 'login','vip']
    },

    {
        path: '/personal', // 我的
        permissions: ['login', 'province'],
        back: false
    },
    {
        path: '/chose_batch', // 批次
        permissions: ['login', 'province', 'score']
    },
    {
        path: '/preBatch', // 提前批
        permissions: ['login', 'province', 'vip']
    },
    {
        path: '/subject_analysis', //
        permissions: ['login','vip']
    },
    {
        path: '/assess_info', //
        permissions: ['login','vip','score']
    },
]
const confirmFn = (content, confirmBack, backFn) => {
    ElMessageBox.confirm(
        content,
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            confirmBack()
        })
        .catch(() => {
            if (backFn){
                backFn()
                return
            }
            if (window.history.length > 1) {
                router.go(-1);
            } else {
                router.push({ name: 'home' });
            }
        })
}
export const checkStatus = (backFn=toHome) => {
    const userInfo = useInfoStore()
    if (userInfo?.backUrl){
        const obj = JSON.parse(JSON.stringify(userInfo.backUrl))
        userInfo.setKey('backUrl','')
        userInfo.setKey('backType',0)
        router.push({path: obj.route, query:obj.query})
    }else {
        backFn()
    }
}
export const toHome = () => {
    router.replace( {
        path: '/home'
    })
}
/**
 * 校验权限
 */
export const checkPermissions = ({needBack,infos} = {needBack: true,infos}) => {
    return new Promise((resolve, reject) => {
        const userStore = useInfoStore()
        const userInfo = userStore.baseInfo
        const token = localStorage.getItem('jwt')
        if (infos) {
            const currentPage = checkPageList.find(item => item.path === infos.path)
            if (currentPage) {
                if (currentPage.permissions.includes('login')) {
                    if (token) {
                        if (currentPage.permissions.length == 1 && currentPage.permissions.includes('login')) {
                            resolve(true)
                        } else {
                            getUserBaseInfo().then(res => {
                                const {provinceId, score} = res?.data?.data
                                if (currentPage.permissions.includes('province') && !provinceId) {
                                    userStore.setKey('backUrl', {route: infos.path, query: infos.query})
                                    // confirmFn('请先完善注册信息',()=>{
                                    //
                                    // },needBack?'':()=>{})
                                    userStore.setKey('backType',2)
                                    reject(false)
                                    return
                                }
                                if (currentPage.permissions.includes('score') && !score) {
                                    if (!currentPage.hasOwnProperty('back')) {
                                        userStore.setKey('backUrl', {route: infos.path, query: infos.query})
                                    }
                                    // confirmFn('请先完善选科及分数信息',()=>{
                                    //
                                    // },needBack?toHome:()=>{
                                    // })
                                    userStore.setKey('backType',3)
                                    reject(false)
                                    return
                                }
                                if (currentPage.permissions.includes('vip') && !userInfo?.is_vip) {
                                    if (!currentPage.hasOwnProperty('back')) {
                                        userStore.setKey('backUrl', {route: infos.path, query: infos.query})
                                    }
                                    // uni.setStorageSync('vipTip',1)
                                    // confirmFn('该功能需要VIP权限，是否开通VIP',()=>{
                                    //
                                    // })
                                    userStore.setKey('backType',4)
                                    reject(false)
                                    return
                                }
                                resolve(true)
                            })
                        }
                    } else {
                        if (!currentPage.hasOwnProperty('back')) {
                            userStore.setKey('backUrl', {route: infos.path, query: infos.query})
                        }

                        userStore.setKey('backType',1)
                        // confirmFn('请先登录',()=>{
                        //
                        // },needBack?toHome:()=>{})
                        reject(false)
                    }
                }
            } else {
                resolve(true)
            }
        } else {
            reject(false)
        }
    })

}